<app-nav></app-nav>

<section class="categorias">

  <!-- ═══════════ HERO CAROUSEL ═══════════ -->
  <header class="cat__hero">
    <div class="cat__heroCarousel">
      <img class="cat__heroImg" [class.active]="showA" [src]="leftA" alt="Hero A" />
      <img class="cat__heroImg" [class.active]="!showA" [src]="leftB" alt="Hero B" />
    </div>

    <div class="cat__heroOverlay">
      <div class="cat__heroContent">
        <a class="back-btn" [routerLink]="['/principal']">← Volver a Pueblos</a>
        <div class="cat__heroBadge">Quindío · Colombia</div>
        <h1 class="cat__heroTitle">{{ data?.nombre || (townSlug | titlecase) }}</h1>
        <p class="cat__heroSub">{{ tipos.length }} categoría{{ tipos.length !== 1 ? 's' : '' }} disponible{{ tipos.length !== 1 ? 's' : '' }}</p>
      </div>
    </div>

    <!-- Dots indicadores -->
    <div class="cat__heroDots">
      <span class="cat__heroDot" [class.active]="showA"></span>
      <span class="cat__heroDot" [class.active]="!showA"></span>
    </div>
  </header>

  <!-- ═══════════ SEARCH BAR ═══════════ -->
  <div class="cat__searchBar">
    <form class="cat__searchPill" (ngSubmit)="onSearch()">
      <svg width="16" height="16" fill="none" viewBox="0 0 24 24" class="cat__searchIcon">
        <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="2"/>
        <path d="M20 20l-3-3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      <input
        type="text" name="q" [(ngModel)]="query"
        placeholder="Busca en {{ data?.nombre || (townSlug | titlecase) }}..."
        autocomplete="off"
      />
      <button type="submit" (click)="haptic.medium()">Buscar</button>
    </form>
  </div>

  <!-- ═══════════ SEARCH PANEL ═══════════ -->
  @if (showPanel) {
    <div class="searchOverlay" (click)="closePanel()"></div>
    <div class="searchPanel" (click)="$event.stopPropagation()">
      <div class="searchPanel__head">
        <strong>Resultados para "{{ query }}"</strong>
        <button type="button" (click)="closePanel()">✕</button>
      </div>
      @if (results.length === 0) {
        <p class="searchEmpty">No se encontraron resultados.</p>
      } @else {
        <div class="searchList">
          @for (r of results; track r.title) {
            <button type="button" class="searchItem" (click)="goResult(r)">
              <img *ngIf="r.img" [src]="r.img" alt="" />
              <div class="searchItem__text">
                <div class="searchItem__title">
                  <span class="searchItem__name">{{ r.title }}</span>
                  <span class="tag" [class.tagLugar]="r.kind==='lugar'" [class.tagCat]="r.kind==='categoria'">
                    {{ r.kind === 'categoria' ? 'Categoría' : 'Lugar' }}
                  </span>
                </div>
                <div class="searchItem__sub">{{ r.subtitle }}</div>
              </div>
            </button>
          }
        </div>
      }
    </div>
  }

  <!-- ═══════════ PANEL MAIN + SIDEBAR ═══════════ -->
  <div class="cat__panel">

    <!-- ═══════════ MAIN ═══════════ -->
    <main class="cat__main">

      <!-- Loading -->
      <app-skeleton *ngIf="loadingTipos" type="categoria" [count]="8" />

      <!-- Vacío -->
      <app-empty
        *ngIf="!loadingTipos && tipos.length === 0"
        type="categoria"
        title="Sin categorías aún"
        description="Este pueblo aún no tiene categorías registradas. Pronto habrá más destinos disponibles."
        actionLabel="Explorar otros pueblos"
        actionRoute="/principal">
      </app-empty>

      <!-- Grid de categorías -->
      <div class="cat__grid"
        *ngIf="!loadingTipos && tipos.length > 0"
        staggerList
        [staggerDelay]="70"
        staggerFrom="bottom">
        <button
          class="cat__card"
          type="button"
          *ngFor="let t of tipos"
          [sharedElement]="'/lugares/' + townSlug + '/tipo/' + t.id_tipo"
          [sharedKey]="'tipo-' + t.id_tipo"
          [sharedImage]="portadaTipo(t.id_tipo)"
        >
          <div class="cat__cardImgWrap">
            <img [src]="portadaTipo(t.id_tipo)" [alt]="t.nombre_tipo" />
          </div>
          <div class="cat__cardBody">
            <span class="cat__cardName">{{ t.nombre_tipo | titlecase }}</span>
            <span class="cat__cardCta">Explorar →</span>
          </div>
        </button>
      </div>

    </main>

  </div>
</section>

<!-- CHATBOT FLOTANTE MÓVIL -->
<div class="chatFab__backdrop" *ngIf="chatOpen" (click)="closeChatMobile()"></div>

<div class="chatFab__panel" [class.chatFab__panel--open]="chatOpen">
  <div class="chatFab__panelHeader">
    <div class="chatFab__panelHeaderLeft">
      <div class="aiPanel__avatar">
        <svg width="16" height="16" fill="none" viewBox="0 0 24 24">
          <path d="M12 2L13.5 8.5L20 10L13.5 11.5L12 18L10.5 11.5L4 10L10.5 8.5L12 2Z" fill="#fff" opacity="0.9"/>
        </svg>
      </div>
      <div>
        <div class="chatFab__panelName">Asistente TripGo</div>
        <div class="aiPanel__status">
          <span class="aiPanel__dot"></span>
          En línea · IA activa
        </div>
      </div>
    </div>
    <button class="chatFab__panelClose" type="button" (click)="closeChatMobile()">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
    </button>
  </div>

  <div class="aiPanel__suggestions">
    <span class="aiPanel__sugLabel">Sugerencias rápidas</span>
    <div class="aiPanel__chips">
      <button class="aiPanel__chip" type="button" (click)="askAI('¿Qué lugares me recomiendas en ' + townSlug + '?')">📍 Lugares top</button>
      <button class="aiPanel__chip" type="button" (click)="askAI('Plan romántico en ' + townSlug)">💫 Plan romántico</button>
      <button class="aiPanel__chip" type="button" (click)="askAI('Plan aventura en ' + townSlug)">🏔️ Aventura</button>
      <button class="aiPanel__chip" type="button" (click)="askAI('¿Qué comer en ' + townSlug + '?')">🍽️ Gastronomía</button>
    </div>
  </div>

  <div class="aiPanel__chat" #chatBoxMobile>
    <div *ngFor="let msg of chatMessages" class="aiMsg" [class.aiMsg--user]="msg.role==='user'" [class.aiMsg--ai]="msg.role==='ai'">
      <div *ngIf="msg.role==='ai'" class="aiMsg__avatar">
        <svg width="12" height="12" fill="none" viewBox="0 0 24 24">
          <path d="M12 2L13.5 8.5L20 10L13.5 11.5L12 18L10.5 11.5L4 10L10.5 8.5L12 2Z" fill="#fff"/>
        </svg>
      </div>
      <div class="aiMsg__bubble" [class.aiMsg__bubble--user]="msg.role==='user'">{{ msg.text }}</div>
    </div>
    <div *ngIf="aiLoading" class="aiMsg aiMsg--ai">
      <div class="aiMsg__avatar">
        <svg width="12" height="12" fill="none" viewBox="0 0 24 24">
          <path d="M12 2L13.5 8.5L20 10L13.5 11.5L12 18L10.5 11.5L4 10L10.5 8.5L12 2Z" fill="#fff"/>
        </svg>
      </div>
      <div class="aiMsg__bubble">
        <div class="aiDots"><span></span><span></span><span></span></div>
      </div>
    </div>
  </div>

  <form class="aiPanel__inputWrap" (ngSubmit)="sendAIMessage()">
    <input type="text" [(ngModel)]="aiQuery" name="aiQueryMobile" placeholder="Pregunta lo que quieras..." [disabled]="aiLoading" autocomplete="off"/>
    <button type="submit" [disabled]="aiLoading || !aiQuery.trim()">
      <svg width="16" height="16" fill="none" viewBox="0 0 24 24">
        <path d="M22 2L11 13M22 2L15 22l-4-9-9-4 20-7z" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </form>
</div>

<app-footer></app-footer>